module.exports = __webpack_public_path__ + "static/media/SnappyFaceBackup.2cb760eb.svg";